 <p-dialog [header]="Header || defaultHeaderText"
           [(visible)]="Display"
           [modal]="true"
           [resizable]="false"
           [focusOnShow]="true"
           [draggable]="false"
           (onHide)="Display = false; DisplayBack.emit()">
   <div [style.min-width]="minWidth" [style.min-height]="minHeight" [innerHTML]="Message"></div>
   <p-footer>
     <button class="btn-info btn-primary"
             type="button"
             (click)="Display = false; DisplayBack.emit(true)"
     >{{(confirmButton | dictionary) || 'Ok'}}</button>
   </p-footer>
 </p-dialog>
